<template>
  <div class="content-header">
    <div class="d-flex justify-content-between align-items-center">
        <h3>{{ title }}</h3>
        <!-- <BButton><i class="fas fa-plus"></i>{{ text }}</BButton> -->
    </div>
  </div>
</template>

<script>
// import { BButton } from "bootstrap-vue-next";

export default {
    props: {
        title: String,
        text: String,
    },
    components: {
        // BButton
    },
    setup(){

    }

}
</script>

<style>

</style>